import { createFileRoute } from '@tanstack/react-router';

import { ExpensesLayout } from '@/features/expenses/expenses-layout';

export const Route = createFileRoute('/__authenticated/expenses')({
	staticData: { titleKey: 'navigation.expenses' },
	component: ExpensesLayout,
});
